import {Component} from '@angular/core';

/**
 * Generated class for the SellionsSpinnerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'sellions-spinner',
  templateUrl: 'sellions-spinner.html'
})
export class SellionsSpinnerComponent {
  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-spinner/sellions-spinner.ts